const generalRoutes = [
  {
    path: "/app",
    name: "App",
    component: () => import("../layout"),
    children: [
      {
        path: "/app/system",
        name: "Device",
        title: "系统设置",
        icon: {
          type: "iconfont",
          iconName: "icon-peizhi",
        },
        redirect: "/app/system/accountmanage",
        component: () => import("../layout/pageWrapper"),
        children: [
          {
            path: "/app/system/accountmanage",
            name: "AccountManage",
            title: "账号管理",
            icon: {
              type: "iconfont",
              iconName: "icon-dian",
            },
            component: () =>
              import("../generalViews/systemConfig/accountManage"),
          },
          {
            path: "/app/system/rolemanage",
            name: "RoleManage",
            title: "角色管理",
            icon: {
              type: "iconfont",
              iconName: "icon-dian",
            },
            component: () => import("../generalViews/systemConfig/roleinfo"),
          },
          {
            path: "/app/system/department",
            name: "DepartmentManage",
            title: "部门管理",
            icon: {
              type: "iconfont",
              iconName: "icon-dian",
            },
            component: () =>
              import("../generalViews/systemConfig/departmentManage"),
          },
        ],
      },
      {
        path: "/app/screen",
        name: "Screen",
        title: "大屏管理",
        dev: true,
        icon: {
          type: "iconfont",
          iconName: "icon-daping",
        },
        redirect: "/app/system/accountmanage",
        component: () => import("../layout/pageWrapper"),
        children: [
          {
            path: "/app/screen/screenmanage",
            name: "ScreenManage",
            title: "大屏管理",
            dev: true,
            icon: {
              type: "iconfont",
              iconName: "icon-dian",
            },
            component: () => import("../generalViews/screenmanage"),
          },
        ],
      },
      // {
      //   path: "/app/system",
      //   name: "System",
      //   title: "系统配置",
      //   icon: {
      //     type: "iconfont",
      //     iconName: "iconpeizhi",
      //   },
      //   redirect: "/app/system/menusetting",
      //   component: () => import("../layout/pageWrapper"),
      //   children: [
      //     {
      //       path: "/app/system/menusetting",
      //       name: "MenuSetting",
      //       title: "枚举管理",
      //       component: () => import("../generalViews/system/menuSetting"),
      //     },
      //   ],
      // },
    ],
  },
];

export const getRouteChildren = () => {
  return generalRoutes[0].children;
};

export default generalRoutes;
